import classNames from "classnames";
import React from "react";
import "./steps_membership.css";

export interface Step {
  leftText: string;
  rightText: string;
  isCompleted?: boolean;
  helperText?: string;
  isLast?: boolean;
}

const Step = ({
  leftText,
  rightText,
  isCompleted,
  helperText,
  isLast,
}: Step) => (
  <div
    className={classNames(
      "step-container",
      isCompleted ? "completed" : "uncompleted",
      isLast && "last"
    )}
  >
    <span data-testid="membership-step-left-text" className="left-text">
      {leftText}
    </span>

    <div
      className={classNames("step", isCompleted ? "completed" : "uncompleted")}
    ></div>
    <div className="right-content">
      <span data-testid="membership-step-right-text" className="right-text">
        {rightText}
      </span>
      <span
        data-testid="membership-step-right-helper-text"
        className="helper-text"
      >
        {helperText}
      </span>
    </div>
  </div>
);

interface StepsProps {
  steps: Step[];
}

export const Steps = ({ steps }: StepsProps) => (
  <div className="steps-wrapper">
    {steps.map((step, index) => (
      <Step
        key={index}
        leftText={step.leftText}
        rightText={step.rightText}
        isCompleted={step.isCompleted}
        helperText={step.helperText}
        isLast={index === steps.length - 1}
      />
    ))}
  </div>
);
